
import { Component, Vue } from 'vue-property-decorator'
import { Getter, Action } from "vuex-class";
import { getMessageList, sendMessageStatus } from "@/api/shouyin";
import moment from 'moment'

@Component({
  name: 'MessageManage'
})
export default class MessageManage extends Vue {
  @Getter companyId!: string
  @Getter isMultiStore!: boolean;
  refreshing = false
  loading = false
  finished = false
  params: any = {
    pageIndex: 1,
    pageSize: 20
  }
  error = false;
  messageList = []

  mounted() {
    if (!this.isMultiStore) {
      this.getMessageList()
    }
  }

  clearMessage() {
    const messageList = this.messageList.map(item => ({
      msgId: item.msgId
    }));
    console.log('messageList', messageList)
    sendMessageStatus({messageList, storeId: this.companyId}).then((res: any) => {
      this.$toast.success({
        message: '消息全部已读',
        duration: 1000,
        onClose: () => {
          this.params.pageIndex = 1
          this.getMessageList()
        }
      })
    })
  }

  goDetail(item: any) {
    if (item.status === 0) {
      const messageList = [
        {
          msgId: item.msgId
        }
      ]
      sendMessageStatus({messageList, storeId: this.companyId}).then((res: any) => {
        // this.$toast.success({
        //   // message: '消息全部已读',
        //   // duration: 100,
        //   onClose: () => {
        //     // this.getMessageList()
        //   }
        // })
      })
    }
    // notifyNodeId 触发通知的节点事件（1活动确认2活动开始3活动结束4奖品抽完）
    // 活动确认时跳转至活动详情，其他跳转至活动报表
    if (item.notifyNodeId === 1) {
      this.$router.push({
        path: '/marketActivityDetail',
        query: {
          lotteryId: item.lotteryId,
          activityName: item.lotteryName
        }
      })
    } else {
      this.$router.push({
        path: '/activityDetail',
        query: {
          activityName: item.lotteryName,
          lotteryId: item.lotteryId,
          lotteryStartTime: moment(item.lotteryStartTime).format("YYYY-MM-DD"),
          lotteryEndTime: moment(item.lotteryEndTime).format("YYYY-MM-DD")
        }
      })
    }
    // this.messageList = JSON.parse(JSON.stringify(this.messageList))
  }
  /**
   * 下拉刷新
   * */
  onRefresh() {
    this.params.pageIndex = 1
    this.refreshing = true
    this.getMessageList()
  }

  /**
   * 上拉加载更多
   */
  onLoad() {
    this.params.pageIndex++
    this.getMessageList()
  }

  getMessageList() {
     getMessageList({
      ...this.params,
      pageIndex: this.params.pageIndex,
      pageSize: this.params.pageSize,
      storeId: this.companyId || 'none'
     })
      .then((res) => {
        if (this.refreshing || this.params.pageIndex === 1) {
          this.messageList = [];
        }
        this.messageList = this.messageList.concat(res.data.records);
        if (this.params.pageIndex >= res.data.totalPages) {
          this.finished = true;
        } else {
          this.finished = false;
        }
        this.refreshing = false;
      })
      .catch(() => {
        this.finished = true;
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
